import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useChat } from '~/composables/useChat';
import MessageInput from './MessageInput.vue';
import MessageList from './MessageList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Channel',
  props: {
    enableMessaging: { type: Boolean }
  },
  setup(__props: any) {



const { init, destroy } = useChat();
const input = ref<Vue | null>(null);
const textAreaEl = computed(() =>
  (input?.value?.$refs?.textarea as Vue)?.$el?.querySelector('textarea'),
);

const handleFocusInput = () => {
  textAreaEl?.value?.focus();
};

onBeforeMount(async () => {
  await init();
});

onBeforeUnmount(() => {
  destroy();
});

return { __sfc: true,init, destroy, input, textAreaEl, handleFocusInput, MessageInput, MessageList }
}

})